import { Injectable } from '@angular/core';
import { WebSearch } from '@local/client-contracts';
import { isNativeWindow } from '@local/common-web';
import { firstValueFrom } from 'rxjs';
import { WebSearchRpcInvoker } from 'src/app/bar/views/web-search/web-search.rpc-invoker';
import { NativeServicesRpcService } from './rpc.service';

@Injectable({
  providedIn: 'root',
})
export class WebSearchService implements WebSearch.Service {
  private readonly isNativeWindow = isNativeWindow();

  constructor(private nativeRpc: NativeServicesRpcService) {}

  async getService(): Promise<WebSearch.Service> {
    if (this.isNativeWindow) return this.nativeRpc.invokeWith(WebSearchRpcInvoker, 'websearch');

    
    // TODO: allow the request to be proxied via native app

    return null;
  }

  async search(query: WebSearch.SearchRequest): Promise<WebSearch.Result> {
    const svc = await this.getService();

    return svc?.search(query) || { status: 'skipped', items: [], isCached: false };
  }
}
